<template>
    <div>
        <div class="flex flex-wrap">
            <EmployeeStatsItem label="Норма часов" :value="norm" class="mr-5 mb-4" />
            <EmployeeStatsItem label="Запланировано" :value="`${planHours} ч.`" class="mr-5 mb-4" />
            <EmployeeStatsItem label="Основных" :value="`${mainHours} ч.`" class="mr-5 mb-4" />
            <EmployeeStatsItem label="Дополнительных" :value="`${extraHours} ч.`" class="mr-5 mb-4" />
        </div>
        <div class="flex flex-wrap">
            <EmployeeStatsItem label="Смен" :value="shiftsNumber" class="mr-5 mb-4" />
            <EmployeeStatsItem label="Нарушения" :value="warning" class="mr-5 mb-4" />
            <EmployeeStatsItem label="Предупреждения" :value="moderate" class="mr-5 mb-4" />
            <EmployeeStatsItem label="Ставка в час" :value="`${salary} Р`" class="mr-5 mb-4" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { Schedule } from '@/types';
import EmployeeStatsItem from './EmployeeStatsItem.vue'
import { computed } from 'vue'
import { useScheduleStore } from '@/stores/scheduleStore'

const store = useScheduleStore()

interface Props {
    schedule: Schedule
}
const { schedule } = defineProps<Props>()

const getStatValue = (statKey: string, employmentId: string) => {
    const values = store.stats?.[statKey]?.values
    if (!Array.isArray(values)) return 0

    return values.find((item: any) => item.employment_id === employmentId)?.value || 0
}

const planHours = computed(() => getStatValue('plan_hours', schedule.id))
const extraHours = computed(() => getStatValue('additional_hours', schedule.id))
const mainHours = computed(() => planHours.value - extraHours.value)
const moderate = computed(() => schedule.shifts.filter(item => item.violation?.general_status === 'moderate').length)
const warning = computed(() => schedule.shifts.filter(item => item.violation?.general_status === 'warning').length)
const salary = computed(() => schedule.salary_hour || 0)
const shiftsNumber = computed(() => schedule.shifts?.length || 0)
const norm = computed(() => schedule.hours_norm || 0)

</script>
